import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { ErrorHttpResponse, HttpConfig } from '../../../../models/https';
import { notificationsActions } from '../../../../redux/slices/notificationsSlice';
import { useAppDisPatch } from '../../../../redux/store';
import useHttps from '../../../useHttps';
import { Notification } from '../../../../redux/slices/notificationsSlice';

const useGetNotifications = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetNotificationsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching notifications'
    );
  };

  const onGetNotificationsSuccess = useCallback(
    (response: any) => {
      // If response.data exists, use that; otherwise assume response is the notifications array.
      const notificationsArray: Notification[] = response?.data
        ? response.data
        : response;
      const unreadNotifications = notificationsArray.filter(
        (notification) => !notification.isRead
      );
      dispatch(notificationsActions.setNotificationsData(unreadNotifications));
    },
    [dispatch]
  );

  const getNotifications = useCallback(
    () => {
      const urlPath = `notifications`;
      const url: HttpConfig = {
        url: urlPath,
        method: 'get',
      };

      return request(
        url,
        onGetNotificationsSuccess,
        setLoading,
        onGetNotificationsError
      );
    },
    [request, onGetNotificationsSuccess]
  );

  return { getNotifications, loading };
};

export default useGetNotifications;
